import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Family Health History in Progress...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row p-2 pb-0"
}
const _hoisted_6 = { class: "form-group col-12 col-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "health-condition" }, [
  /*#__PURE__*/_createTextVNode(" Health Condition "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_9 = { class: "col-12 row" }
const _hoisted_10 = { class: "form-group col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-patient" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Patient "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship to Patient", -1 /* HOISTED */)
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_16 = { class: "form-group col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "age-of-diagnosis" }, " Age of Diagnosis ", -1 /* HOISTED */)
const _hoisted_18 = ["onUpdate:modelValue", "disabled"]
const _hoisted_19 = { class: "form-group col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "relation-status" }, " Status ", -1 /* HOISTED */)
const _hoisted_21 = ["onUpdate:modelValue", "disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Status", -1 /* HOISTED */)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-group col-md-3" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "col-12 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      (_ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : _createCommentVNode("v-if", true),
      (!_ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TypeaheadInput, {
                ref: "typeaheadInstance",
                getData: _ctx.getHealthCondtionsList,
                value: _ctx.selectedHealthCondition,
                "init-value": _ctx.selectedHealthCondition,
                placeholder: "Enter Health Condition",
                disabled: _ctx.isEdit,
                onValueChanged: _ctx.handleValueChange,
                onBlurredInput: _ctx.v$.familyHealthHistory.Condition.$touch
              }, null, 8 /* PROPS */, ["getData", "value", "init-value", "disabled", "onValueChanged", "onBlurredInput"]),
              (_ctx.v$.familyHealthHistory.Condition.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Health Condition is required."))
                : _createCommentVNode("v-if", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyHealthHistory.PatientRelations, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("select", {
                    name: "relationship-to-patient",
                    class: "form-select",
                    "onUpdate:modelValue": ($event: any) => ((item.RelationshipToPatient) = $event),
                    onBlur: _ctx.v$.familyHealthHistory.PatientRelations[index].RelationshipToPatient.$touch
                  }, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientRelationshipEnum, (value, key) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value,
                        key: key
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12), [
                    [_vModelSelect, item.RelationshipToPatient]
                  ]),
                  (_ctx.v$.familyHealthHistory.PatientRelations[index].RelationshipToPatient.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Relationship is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((item.Age) = $event),
                    placeholder: "Enter Age of Diagnosis",
                    disabled: !item.RelationshipToPatient
                  }, null, 8 /* PROPS */, _hoisted_18), [
                    [_vModelText, item.Age],
                    [_directive_number_only]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    name: "relation-status",
                    class: "form-select",
                    "onUpdate:modelValue": ($event: any) => ((item.Status) = $event),
                    disabled: !item.RelationshipToPatient
                  }, [
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationStatusEnum, (value, key) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_23))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_21), [
                    [_vModelSelect, item.Status]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.familyHealthHistory.PatientRelations.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-danger btn-sm mt-4",
                        onClick: ($event: any) => (_ctx.removeRelationship(index))
                      }, " Remove ", 8 /* PROPS */, _hoisted_25))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm ms-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRelationship()))
              }, " Add Additional Relationship ")
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}